import styled from "styled-components"

export type IllustrationMetadata = {
  name: string
  svg: string
}

export type IllustrationProps = {
  illustration: IllustrationMetadata
  alt?: string
  width?: string
  height?: string
}

const Span = styled.span<{ width?: string; height?: string }>`
  .illustration-class-primary {
    fill: #273664;
  }
  .illustration-class-secondary {
    fill: #cfdcf6;
  }
  .illustration-class-base {
    fill: #ffffff;
  }
  ${({ width, height }) => {
    return `
      svg {
        width: ${width};
        height: ${height};
      }
    `
  }}
`

export const Illustration = ({
  illustration,
  alt,
  width,
  height,
  ...props
}: IllustrationProps) => {
  return (
    <Span
      {...props}
      role="img"
      aria-label={alt}
      width={width}
      height={height}
      dangerouslySetInnerHTML={{
        __html: illustration.svg,
      }}
    />
  )
}
